import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'ArrowDownIcon',
  viewBox: '0 0 16 16',
  path: [
    <path
      key="1"
      d="M2 5L8 11L14 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});
